var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',{attrs:{"id":"status-chip","color":_vm.getColor(),"x-large":_vm.size == 'xl',"large":_vm.size == 'lg',"small":_vm.size == 'sm',"x-small":_vm.size == 'xs'}},[_vm._v(" "+_vm._s(_vm.value)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }